import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from "../contexts/auth";
import { getOrderEditsURL } from '../utils/api';

const useGetOrderEdit = ({ 
        orderId,
        setErrors
    }) => {
        
    const { auth } = useAuth();
    const [ gettingOrderEdit, setGettingOrderEdit ] = useState(false);
    const [ orderEdit, setOrderEdit ] = useState([]);
    const [ gettingOrderEditReqSuccess, setGettingOrderEditReqSuccess ] = useState(false);
    
    useEffect(() => {

        if (gettingOrderEdit && orderId) {
            axios.get(getOrderEditsURL(orderId), 
            {
                headers: {
                    Authorization: `Bearer ${auth.authToken}`
                },
            }).then(result => {
                setGettingOrderEdit(false);
                if (result.status === 200) {
                    // console.log(result.data.data);
                    setGettingOrderEditReqSuccess(true);
                    setOrderEdit(result.data.data);         
                } else {
                    // console.log(result.data.errors);
                    if (setErrors) {
                        setErrors(result.data.errors);
                    }
                    setGettingOrderEditReqSuccess(false);
                    // setOperatorAddErrors(result.data.errors);
                }
            }).catch(e => {
                if (e.response === undefined) {
                    // console.log(e);
                    if (setErrors) {
                        setErrors(['Could not connect to server']);
                    }
                    // setOperatorAddErrors(['Could not connect to server!'])
                } else {
                    // console.log(e.response.data.errors);
                    // setOperatorAddErrors(e.response.data.errors)
                    if (setErrors) {
                        setErrors([e.response.data.errors]);
                    }
                }
                setGettingOrderEditReqSuccess(false);
                setGettingOrderEdit(false);
            });
        }
    }, [gettingOrderEdit]);

    return { orderEdit, gettingOrderEdit, setGettingOrderEdit, gettingOrderEditReqSuccess };
}

export default useGetOrderEdit;